<template>
  <div class="account" v-if="$store.getters.accType !== 'VzAdmin'">
    <div class="type">
      <span>{{ user.accountType }}</span>
    </div>
    <div>
      <form method="post" action="/user/<button-value>" @submit.prevent="changeAccount">
        <select
          type="number"
          name="newAccount_type"
          class="newAccType"
          v-model="newAccType"
        >
          <option value="VzUser">{{ parseTranslation(USER) }}</option>
          <option value="VzAdmin">{{ parseTranslation(ADMIN) }}</option>
          <option
            :class="{ disabled: $store.getters.accType !== 'Root' }"
            :disabled="$store.getters.accType !== 'Root'"
            value="Root"
            >Root</option
          >
        </select>
        <button type="submit" name="button" value="account">
          <span v-if="loading"><Loader color="#fff"/></span>
          <span v-else> {{ parseTranslation(CHANGE) }} </span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-3'

import * as translationUserAccount from './UserAccount.translations'

const { default: translations, ...translationKeys } = translationUserAccount

export default {
  name: 'UserAccount',

  components: {
    Loader,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      newAccType: '',
      loading: false,
    }
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async changeAccount(e) {
      if (this.loading) return

      this.loading = true

      const success = await this.executeSurveyAPICall({
        path: '/user/admin/change-type',
        method: 'POST',
        payload: {
          username: this.user.username,
          accountType: this.newAccType,
        },
      })

      if (!success) return (this.loading = false)

      this.sendMessage(success.message)

      this.loading = false
    },
  },
  created() {
    this.newAccType = this.user.accountType
  },
}
</script>

<style lang="scss" scoped>
.account > div {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.type {
  margin-bottom: 5px;
}
select {
  background: rgba(0, 0, 0, 0);
  @include tipography(14);
  padding: 2px 8px 3px;
  outline: none;
  margin-right: 10px;
  margin-top: 5px;
  border-radius: 15px;
  border: 1px solid $white;
  &:hover,
  &:focus {
    box-shadow: 0px 0px 6px $gray;
  }
  option {
    color: $main-two;
    &.disabled {
      color: $gray;
    }
  }
  .light & {
    border: 1px solid $gray-5;
    color: $gray-6;
  }
}
button[type='submit'] {
  @include btn-style;
  width: 70px;
  display: inline-block;
  @include tipography(12);
  padding: 2px;

  span {
    display: flex;
    justify-content: center;
  }
}
</style>
